import { render, staticRenderFns } from "./CorrectDemand.vue?vue&type=template&id=0eb4ecd3&scoped=true&"
import script from "./CorrectDemand.vue?vue&type=script&lang=js&"
export * from "./CorrectDemand.vue?vue&type=script&lang=js&"
import style0 from "./CorrectDemand.vue?vue&type=style&index=0&id=0eb4ecd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4ecd3",
  null
  
)

export default component.exports